import React from 'react'
import PropTypes from 'prop-types'
import './style.css'


const NRTQuestionContainer = (props) => {

    return (
        <div className='nrt-ead-question'>
            <h4>{props.title}</h4>
            <div className={'question-body'}>
                {props.children}
            </div>
        </div>
    )
}

NRTQuestionContainer.propTypes = {
    title: PropTypes.string.isRequired ,
}

NRTQuestionContainer.defaultProps = {}

export default NRTQuestionContainer



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/Questions/_components/QuestionContainer/index.js